import { c as _c } from "react/compiler-runtime";
import { TextMono } from "@/components/ui/text";
import { useThemeStore } from "@/store/theme-store";
const ColorGridComponent = t0 => {
  const $ = _c(77);
  const {
    prefix: t1
  } = t0;
  const prefix = t1 === undefined ? "ios" : t1;
  const t2 = `var(--${prefix}-foreground)`;
  const t3 = `var(--${prefix}-background)`;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = <ColorBox color={t2} foregroundColor={t3} name="Foreground" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `var(--${prefix}-background)`;
  const t6 = `var(--${prefix}-foreground)`;
  let t7;
  if ($[3] !== t5 || $[4] !== t6) {
    t7 = <ColorBox color={t5} foregroundColor={t6} name="Background" />;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = `var(--${prefix}-primary)`;
  const t9 = `var(--${prefix}-primary-foreground)`;
  let t10;
  if ($[6] !== t8 || $[7] !== t9) {
    t10 = <ColorBox color={t8} foregroundColor={t9} name="Primary" />;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = `var(--${prefix}-primary-foreground)`;
  const t12 = `var(--${prefix}-primary)`;
  let t13;
  if ($[9] !== t11 || $[10] !== t12) {
    t13 = <ColorBox color={t11} foregroundColor={t12} name="Primary Foreground" />;
    $[9] = t11;
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const t14 = `var(--${prefix}-secondary)`;
  const t15 = `var(--${prefix}-secondary-foreground)`;
  let t16;
  if ($[12] !== t14 || $[13] !== t15) {
    t16 = <ColorBox color={t14} foregroundColor={t15} name="Secondary" />;
    $[12] = t14;
    $[13] = t15;
    $[14] = t16;
  } else {
    t16 = $[14];
  }
  const t17 = `var(--${prefix}-secondary-foreground)`;
  const t18 = `var(--${prefix}-secondary)`;
  let t19;
  if ($[15] !== t17 || $[16] !== t18) {
    t19 = <ColorBox color={t17} foregroundColor={t18} name="Secondary Foreground" />;
    $[15] = t17;
    $[16] = t18;
    $[17] = t19;
  } else {
    t19 = $[17];
  }
  const t20 = `var(--${prefix}-accent)`;
  const t21 = `var(--${prefix}-accent-foreground)`;
  let t22;
  if ($[18] !== t20 || $[19] !== t21) {
    t22 = <ColorBox color={t20} foregroundColor={t21} name="Accent" />;
    $[18] = t20;
    $[19] = t21;
    $[20] = t22;
  } else {
    t22 = $[20];
  }
  const t23 = `var(--${prefix}-accent-foreground)`;
  const t24 = `var(--${prefix}-accent)`;
  let t25;
  if ($[21] !== t23 || $[22] !== t24) {
    t25 = <ColorBox color={t23} foregroundColor={t24} name="Accent Foreground" />;
    $[21] = t23;
    $[22] = t24;
    $[23] = t25;
  } else {
    t25 = $[23];
  }
  const t26 = `var(--${prefix}-muted)`;
  const t27 = `var(--${prefix}-muted-foreground)`;
  let t28;
  if ($[24] !== t26 || $[25] !== t27) {
    t28 = <ColorBox color={t26} foregroundColor={t27} name="Muted" />;
    $[24] = t26;
    $[25] = t27;
    $[26] = t28;
  } else {
    t28 = $[26];
  }
  const t29 = `var(--${prefix}-muted-foreground)`;
  const t30 = `var(--${prefix}-muted)`;
  let t31;
  if ($[27] !== t29 || $[28] !== t30) {
    t31 = <ColorBox color={t29} foregroundColor={t30} name="Muted Foreground" />;
    $[27] = t29;
    $[28] = t30;
    $[29] = t31;
  } else {
    t31 = $[29];
  }
  const t32 = `var(--${prefix}-card)`;
  const t33 = `color-mix(in srgb, var(--${prefix}-card-foreground) 50%, transparent)`;
  let t34;
  if ($[30] !== t32 || $[31] !== t33) {
    t34 = <ColorBox color={t32} foregroundColor={t33} name="Card" />;
    $[30] = t32;
    $[31] = t33;
    $[32] = t34;
  } else {
    t34 = $[32];
  }
  const t35 = `var(--${prefix}-card-foreground)`;
  const t36 = `color-mix(in srgb, var(--${prefix}-card) 50%, transparent)`;
  let t37;
  if ($[33] !== t35 || $[34] !== t36) {
    t37 = <ColorBox color={t35} foregroundColor={t36} name="Card Foreground" />;
    $[33] = t35;
    $[34] = t36;
    $[35] = t37;
  } else {
    t37 = $[35];
  }
  const t38 = `var(--${prefix}-popover)`;
  const t39 = `color-mix(in srgb, var(--${prefix}-popover-foreground) 50%, transparent)`;
  let t40;
  if ($[36] !== t38 || $[37] !== t39) {
    t40 = <ColorBox color={t38} foregroundColor={t39} name="Popover" />;
    $[36] = t38;
    $[37] = t39;
    $[38] = t40;
  } else {
    t40 = $[38];
  }
  const t41 = `var(--${prefix}-popover-foreground)`;
  const t42 = `color-mix(in srgb, var(--${prefix}-popover) 50%, transparent)`;
  let t43;
  if ($[39] !== t41 || $[40] !== t42) {
    t43 = <ColorBox color={t41} foregroundColor={t42} name="Popover Foreground" />;
    $[39] = t41;
    $[40] = t42;
    $[41] = t43;
  } else {
    t43 = $[41];
  }
  const t44 = `var(--${prefix}-destructive)`;
  const t45 = `var(--${prefix}-destructive-foreground)`;
  let t46;
  if ($[42] !== t44 || $[43] !== t45) {
    t46 = <ColorBox color={t44} foregroundColor={t45} name="Destructive" />;
    $[42] = t44;
    $[43] = t45;
    $[44] = t46;
  } else {
    t46 = $[44];
  }
  const t47 = `var(--${prefix}-destructive-foreground)`;
  const t48 = `var(--${prefix}-destructive)`;
  let t49;
  if ($[45] !== t47 || $[46] !== t48) {
    t49 = <ColorBox color={t47} foregroundColor={t48} name="Destructive Foreground" />;
    $[45] = t47;
    $[46] = t48;
    $[47] = t49;
  } else {
    t49 = $[47];
  }
  let t50;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = Array.from({
      length: 6
    });
    $[48] = t50;
  } else {
    t50 = $[48];
  }
  let t51;
  if ($[49] !== prefix) {
    t51 = t50.map((_, index) => {
      const grayExt = index === 0 ? "" : index + 1;
      return <ColorBox key={index} color={`var(--${prefix}-grey${grayExt})`} foregroundColor={`color-mix(in srgb, var(--${prefix}-foreground) 50%, transparent)`} name={`Grey${grayExt}`} />;
    });
    $[49] = prefix;
    $[50] = t51;
  } else {
    t51 = $[50];
  }
  const t52 = `var(--${prefix}-border)`;
  const t53 = `color-mix(in srgb, var(--${prefix}-foreground) 50%, transparent)`;
  let t54;
  if ($[51] !== t52 || $[52] !== t53) {
    t54 = <ColorBox color={t52} foregroundColor={t53} name="Border/ring" />;
    $[51] = t52;
    $[52] = t53;
    $[53] = t54;
  } else {
    t54 = $[53];
  }
  const t55 = `var(--${prefix}-input)`;
  const t56 = `color-mix(in srgb, var(--${prefix}-foreground) 50%, transparent)`;
  let t57;
  if ($[54] !== t55 || $[55] !== t56) {
    t57 = <ColorBox color={t55} foregroundColor={t56} name="Input" />;
    $[54] = t55;
    $[55] = t56;
    $[56] = t57;
  } else {
    t57 = $[56];
  }
  let t58;
  if ($[57] !== t10 || $[58] !== t13 || $[59] !== t16 || $[60] !== t19 || $[61] !== t22 || $[62] !== t25 || $[63] !== t28 || $[64] !== t31 || $[65] !== t34 || $[66] !== t37 || $[67] !== t4 || $[68] !== t40 || $[69] !== t43 || $[70] !== t46 || $[71] !== t49 || $[72] !== t51 || $[73] !== t54 || $[74] !== t57 || $[75] !== t7) {
    t58 = <div className="grid h-full grid-cols-4 content-center items-center gap-px p-px">{t4}{t7}{t10}{t13}{t16}{t19}{t22}{t25}{t28}{t31}{t34}{t37}{t40}{t43}{t46}{t49}{t51}{t54}{t57}</div>;
    $[57] = t10;
    $[58] = t13;
    $[59] = t16;
    $[60] = t19;
    $[61] = t22;
    $[62] = t25;
    $[63] = t28;
    $[64] = t31;
    $[65] = t34;
    $[66] = t37;
    $[67] = t4;
    $[68] = t40;
    $[69] = t43;
    $[70] = t46;
    $[71] = t49;
    $[72] = t51;
    $[73] = t54;
    $[74] = t57;
    $[75] = t7;
    $[76] = t58;
  } else {
    t58 = $[76];
  }
  return t58;
};
const ColorBox = t0 => {
  const $ = _c(10);
  const {
    color,
    foregroundColor,
    name
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = {
      backgroundColor: color
    };
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== foregroundColor) {
    t2 = {
      color: foregroundColor
    };
    $[2] = foregroundColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name || $[5] !== t2) {
    t3 = <TextMono className="px-1 py-2 !text-[0.675rem]/3.5 sm:!text-[0.675rem]/3.5 lg:px-2" style={t2}>{name}</TextMono>;
    $[4] = name;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="bg-background flex flex-col"><div className="flex h-20 w-full min-w-24 items-end" style={t1}>{t3}</div></div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const platformComponents = {
  ios: () => ColorGridComponent({
    prefix: "ios"
  }),
  android: () => ColorGridComponent({
    prefix: "android"
  }),
  web: () => ColorGridComponent({
    prefix: "web"
  })
};
export const ColorGrid = () => {
  const $ = _c(2);
  const platform = useThemeStore(_temp);
  const Component = platformComponents[platform];
  let t0;
  if ($[0] !== Component) {
    t0 = <Component />;
    $[0] = Component;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(state) {
  return state.platform;
}